import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import { type DrawerInitialState } from './types';

const initialState: DrawerInitialState = {
  isDrawerOpen: false,
  drawerType: null,
  drawerData: {},
};

export const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    openDrawer: (
      state,
      {
        payload: { drawerType, drawerData },
      }: PayloadAction<Omit<DrawerInitialState, 'isDrawerOpen'>>,
    ) => {
      state.isDrawerOpen = true;
      state.drawerType = drawerType;
      state.drawerData = drawerData;
    },
    closeDrawer: (state) => {
      state.isDrawerOpen = false;
    },
  },
});

export const { reducer: drawerReducer } = drawerSlice;
